import React, { useState } from "react";
import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import "./alerts.css";
import { useTranslation } from "react-i18next";
import navBarEn from "../../translations/en/navbar.json";
import navBarEs from "../../translations/es/navbar.json";
import Helmet from "react-helmet";
import AlertsImg from "../../assets/imgs/alerts/alerts-img.png";
import { FaChevronDown, FaChevronUp, FaExternalLinkAlt } from "react-icons/fa";

import CumplimientoEs from "../../assets/pdfs/Cumplimiento-de-la-Regu-es.pdf";
import CumplimientoEn from "../../assets/pdfs/Cumplimiento-de-la-Regu-en.pdf";

const AlertItem = ({ title, date, summary, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation("alerts");

  return (
    <div className={`alert-card ${isOpen ? "open" : ""}`}>
      <div className="alert-card-header">
        <h2 className="title-alert">{title}</h2>
        <p className="date-alert">{date}</p>
        <p className="alert-summary">{summary}</p>
      </div>

      <div className="btn-toggle-container">
        <button
          className="btn-toggle-alert"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? t("btn-more.learn-less") : t("btn-more.learn-more")}
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </button>
      </div>

      {isOpen && <div className="alert-details">{children}</div>}
    </div>
  );
};

function Alerts() {
  const [tAlerts] = useTranslation("alerts");
  const [tSMetaData] = useTranslation("metaData");
  const currentLang = localStorage.getItem("lng") || "es";

  sessionStorage.setItem("routeEs", `/${navBarEs["category-services"].alert}`);
  sessionStorage.setItem("routeEn", `/${navBarEn["category-services"].alert}`);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("alertas.title")}</title>
        <meta name="description" content={tSMetaData("alertas.description")} />
      </Helmet>
      <ScrollToTop />
      <Navbar />

      <div className="container-fluid bg-innovation d-flex justify-content-center align-items-center">
        <img className="alerts-img" src={AlertsImg} alt="Alerts" />
        <div className="ps-3 text-white text-center text-md-start">
          <p className="m-0 fs-2 fw-bold">{tAlerts("title.title-page")}</p>
          <p className="m-0 fs-2 font-regular">{tAlerts("alerts-info.text2")}</p>
        </div>
      </div>

      <div className="container-fluid py-5 bg-alert">
        <div className="container">
          <div className="mb-5">
            <p className="alert-info m-0">
              {tAlerts("alerts-info.text1")}
              <span className="fw-bold font-semibold">
                {tAlerts("alerts-info.text2")}
              </span>
              {tAlerts("alerts-info.text3")}
            </p>
          </div>

          {/* 1. PROTOCOLO ACAS */}
          <AlertItem
            title={tAlerts("acas.text1")}
            date={tAlerts("acas.text2")}
            summary={tAlerts("acas.text3")}
          >
            <div className="alert-details-content">
              <p className="alert-detail-p">
                {tAlerts("acas.info1")}
              </p>

              <div className="alert-sub-item">
                <div className="alert-number-circle">1</div>
                <div>
                  {tAlerts("acas.info2")}
                </div>
              </div>

              <div className="alert-sub-item">
                <div className="alert-number-circle">2</div>
                <div>
                  {tAlerts("acas.info3")}
                </div>
              </div>

              <p className="alert-detail-p mt-4">
                <em>{tAlerts("acas.info4")}</em>
              </p>
              <p className="alert-detail-p">
                <strong>{tAlerts("acas.info5")}</strong>
              </p>

              <div className="alert-link-box">
                <p className="m-0 mb-2">{tAlerts("acas.info6")}</p>
                <a href={tAlerts("acas.link")} target="_blank" rel="noopener noreferrer">
                  {tAlerts("acas.link")} <FaExternalLinkAlt size={12} className="ms-1" />
                </a>
              </div>
            </div>
          </AlertItem>

          {/* 2. REGULACIÓN ICS2 */}
          <AlertItem
            title={tAlerts("notice1.text1")}
            date={tAlerts("notice1.text2")}
            summary={tAlerts("notice1.text3")}
          >
            <div className="alert-details-content">
              <p className="alert-detail-p">{tAlerts("notice1.info1")}</p>
              <ul>
                <li className="alert-detail-p">{tAlerts("notice1.info2")}</li>
                <li className="alert-detail-p">{tAlerts("notice1.info3")}</li>
                <li className="alert-detail-p">{tAlerts("notice1.info4")}</li>
                <li className="alert-detail-p">{tAlerts("notice1.info5")}</li>
                <ul className="mt-2">
                  <li className="alert-detail-p">{tAlerts("notice1.info6")}</li>
                  <li className="alert-detail-p">{tAlerts("notice1.info7")}</li>
                  <li className="alert-detail-p">{tAlerts("notice1.info8")}</li>
                  <li className="alert-detail-p">{tAlerts("notice1.info9")}</li>
                </ul>
              </ul>
              <p className="alert-detail-p">
                {tAlerts("notice1.info10")}
                <a href={currentLang === "es" ? CumplimientoEs : CumplimientoEn} target="_blank" rel="noopener noreferrer">
                  {tAlerts("notice1.info11")}
                </a>
              </p>
              <div className="alert-link-box">
                <p className="m-0 mb-2">{tAlerts("notice1.info12")}</p>
                <a href="https://taxation-customs.ec.europa.eu/customs-4/customs-security_en" target="_blank" rel="noopener noreferrer">
                  {tAlerts("notice1.info13")} <FaExternalLinkAlt size={12} className="ms-1" />
                </a>
              </div>
            </div>
          </AlertItem>

          {/* Otras alertas se pueden añadir siguiendo el mismo patrón */}
          <AlertItem
            title={tAlerts("notice2.text1")}
            date={tAlerts("notice2.text2")}
            summary={tAlerts("notice2.text3")}
          >
            <p className="alert-detail-p">
              {tAlerts("notice2.notice-info")}
              <a href="/servicios/especializados/pharma" target="_blank" rel="noopener noreferrer">{tAlerts("notice2.link")}</a>
            </p>
          </AlertItem>

          <AlertItem
            title={tAlerts("notice3.text1")}
            date={tAlerts("notice3.text2")}
            summary={tAlerts("notice3.text3")}
          >
            <p className="alert-detail-p">
              {tAlerts("notice3.notice-info")}
              <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" target="_blank" rel="noopener noreferrer">{tAlerts("notice3.link")}</a>
            </p>
          </AlertItem>

          <AlertItem
            title={tAlerts("notice4.text1")}
            date={tAlerts("notice4.text2")}
            summary={tAlerts("notice4.text3")}
          >
            <p className="alert-detail-p">
              {tAlerts("notice4.notice-info")}
              <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" target="_blank" rel="noopener noreferrer">{tAlerts("notice4.link")}</a>
            </p>
          </AlertItem>

          <AlertItem
            title={tAlerts("notice5.text1")}
            date={tAlerts("notice5.text2")}
            summary={tAlerts("notice5.text3")}
          >
            <p className="alert-detail-p">
              {tAlerts("notice5.notice-info")}
              <a href="/politicas/no-show" target="_blank" rel="noopener noreferrer">{tAlerts("notice5.link")}</a>
            </p>
          </AlertItem>

          <AlertItem
            title={tAlerts("notice6.text1")}
            date={tAlerts("notice6.text2")}
            summary={tAlerts("notice6.text3")}
          >
            <p className="alert-detail-p">
              {tAlerts("notice6.notice-info")}
              <a href="/noticias/iata-certification" target="_blank" rel="noopener noreferrer">{tAlerts("notice6.link")}</a>
            </p>
          </AlertItem>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default Alerts;
